<template>
	<div class="footer mt30">
		<div class="container">
			<div class="flex">
				<div class="left m-100"></div>
				<div class="middle m-100">
					<div class="footnav">
						<a>关于我们</a>
						|
						<a>联系方式</a>
					</div>
					<div class="copyright">
						<!-- <span>网站主办：国家卫生健康委人才交流服务中心</span>
						<a target="_blank" href="https://beian.miit.gov.cn/"><span>京ICP备 14010889 号</span></a>
						<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11040202450052">
							<span>
								<img src="../assets/index/bah.png" alt="" />
								京公网安备 11040202450052号
							</span>
						</a> -->
						<span>Copyright@http://www,ortho-k,com,cnallrightsreserved沪ICP备17047259号-4Powered by中华角膜塑形镜学会 2024-2028<br />
                              地址:香港九龙旺角道33号凯途发展大厦7楼学会涉及广告及商业收费项目均由业务承办单位全权代理 咨询邮箱:77017545@qq.com</span>
					</div>
					<div class="wztjnew"></div>
				</div>
				<div class="right flex">
					<img src="../assets/index/jmsx.png" alt="中华角膜塑形镜学会" />
					<span>
						扫码
						<br />
						手机查看
						<br />
						本网站
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Footer',
	data() {
		return {};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../assets/index/common.css"></style>
<style scoped src="../assets/index/footer.css"></style>
<style scoped>
@media (max-width: 767px) {
    .right.flex {
        display: none;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/footer.vue